export class StackedChart {
  constructor() {
    document.querySelectorAll('.with-hidden-label').forEach(value => {
      let bar = value.querySelector('.box');
      bar.addEventListener('mouseenter', () => value.classList.add('label-appear'));
      bar.addEventListener('mouseleave', () => value.classList.remove('label-appear'))
    });
  }
}
